import { create } from "zustand";
import { urlParams } from "../constants/AppConstants";

export const useListViewStore = create((set, get) => ({
  // State
  selectedChannels: [], // Array of channel values (serviceIds, _phone___xxx, _team___xxx)
  selectedFlagFilter: [], // Array for multiple flags
  selectedAssignees: [], // Array of assignee userIds
  selectedReadStatus: "all", // "all" | "read" | "unread"
  selectedConversationStatus: [], // Array for conversation status: "unread", "open", "close"
  selectedDateRange: null, // [startDate, endDate] dayjs objects
  activeTab: urlParams.get("hs-inbox-view") || "all",
  searchBy: "serviceId",
  loading: false,
  data: [],

  // Actions
  setSelectedChannels: (channels) => {
    // Accept either array or single value for backward compatibility
    const channelArray = Array.isArray(channels) ? channels : (channels ? [channels] : []);
    set({ selectedChannels: channelArray });
  },

  setSelectedFlagFilter: (flags) => {
    // Accept either array or single value for backward compatibility
    const flagArray = Array.isArray(flags) ? flags : (flags ? [flags] : []);
    set({ selectedFlagFilter: flagArray });
  },

  setActiveTab: (tab) => {
    set({ activeTab: tab });
  },

  setSearchBy: (searchBy) => {
    set({ searchBy });
  },

  setSelectedAssignees: (assignees) => {
    // Accept either array or single value for backward compatibility
    const assigneeArray = Array.isArray(assignees) ? assignees : (assignees ? [assignees] : []);
    set({ selectedAssignees: assigneeArray });
  },

  setSelectedReadStatus: (readStatus) => {
    set({ selectedReadStatus: readStatus || "all" });
  },

  setSelectedDateRange: (dateRange) => {
    set({ selectedDateRange: dateRange });
  },

  setSelectedConversationStatus: (statuses) => {
    // Accept either array or single value for backward compatibility
    const statusArray = Array.isArray(statuses) ? statuses : (statuses ? [statuses] : []);
    set({ selectedConversationStatus: statusArray });
  },

  setLoading: (loading) => {
    set({ loading });
  },

  setData: (data) => {
    // Support both direct values and functional updates (like React's setState)
    // The function receives the previous data value as 'prev' parameter
    if (typeof data === 'function') {
      set((state) => {
        const prevData = state.data;
        const newData = data(prevData);
        return { data: newData };
      });
    } else {
      set({ data });
    }
  },

  // Reset all filters
  resetFilters: () => {
    set({
      selectedChannels: [],
      selectedFlagFilter: [],
      selectedAssignees: [],
      selectedReadStatus: "all",
      selectedConversationStatus: [],
      selectedDateRange: null,
      activeTab: "all",
      searchBy: "serviceId",
    });
  },

  // Clear all state
  clearStore: () => {
    set({
      selectedChannels: [],
      selectedFlagFilter: [],
      selectedAssignees: [],
      selectedReadStatus: "all",
      selectedConversationStatus: [],
      selectedDateRange: null,
      activeTab: "all",
      searchBy: "serviceId",
      loading: false,
      data: [],
    });
  },
}));